export default "__VITE_ASSET__PXoxoVJy__"